import React, { Component } from 'react';
import Widget from '../Widget';

export default class DemoWidget extends Component {
  // Render Main screen using the data from `run_query`

  renderMainScreen(data) {
    return (
      <div>
        <ul className="u-mb-0">{data.map(user => this.renderUser(user))}</ul>
      </div>
    );
  }

  renderUser(user) {
    return <li key={user.id}>{user.full_name}</li>;
  }

  // Render Configuration screen

  renderConfigurationScreen(configs, updateConfigState) {
    return (
      <span>
        <div className="widget-configs-label">Sort by</div>
        {this.renderSortOption(configs, updateConfigState, 'asc', 'A-Z')}
        {this.renderSortOption(configs, updateConfigState, 'desc', 'Z-A')}
      </span>
    );
  }

  renderSortOption(configs, updateConfigState, direction, label) {
    const inputName = `sort_by_${direction}`;
    return (
      <div className="radio">
        <label htmlFor={inputName}>
          <input
            type="radio"
            name={inputName}
            id={inputName}
            onChange={this.changeSortBy.bind(this, updateConfigState, direction)}
            checked={configs.sort_direction === direction}
          />{' '}
          {label}
        </label>
      </div>
    );
  }

  changeSortBy(updateConfigState, newDirection) {
    updateConfigState({ sort_direction: newDirection });
  }

  render() {
    return (
      <Widget
        renderMainScreen={this.renderMainScreen.bind(this)}
        renderConfigurationScreen={this.renderConfigurationScreen.bind(this)}
        {...this.props}
      />
    );
  }
}
